<template lang="pug">
  .attach-file(
  :class="{'attach-file_vertical' : mode === 'vertical'}"
  )
    .attach-file__list
      .attach-file__item(
      v-if="localAttachments.length > 0"
      v-for="file in localAttachments"
      )
        .attached-file
          .button
            .button__icon
              img(src="@/assets/images/icons/doc.svg")
            .button__text(
            href="#"
            ) {{ file.name }}
          .attached-file__button-remove
            button-delete(
            @onButtonClick="deleteFile(file.id)"
            )
      .attach-file__item
        .input-file
          label.input-file__label
            .button
              .button__icon
                img(src="@/assets/images/icons/clip.svg" v-if="!pending")
                .button__icon.pending(v-else)
              .button__text Добавить файл
            input.input-file__input(
              v-if="!pending"
              type="file"
              @change="onAddFile"
            )
            .input-file__outline
          .form
            .form__elem.form__elem_align-right.form__elem_full
              .form-elem
                .form-elem__error(
                  v-if="currentErrorMessage.length > 0"
                ) {{ currentErrorMessage }}
</template>

<script>
import { mapActions } from "vuex";
import ButtonDelete from "../button-delete/button-delete";

export default {
  name: "attach-file",
  components: { ButtonDelete },
  props: {
    mode: {
      type: String,
      default: "",
    },
    attachmentType: {
      type: String,
      default: "",
    },
    attachments: {
      type: Array,
      default: () => [],
    },
    fieldname: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pending: false,
      attachmentTypes: {
        image: "1",
        avatar: "2",
        passport: "3",
        file: "4",
        request: "5",
        medical: "6",
        birth_certificate: "7",
        inn: "8",
        snils: "9",
        contact_attachments: "10",
        award: "11",
      },
      currentErrorMessage: "",
      errorMessage: {
        file: "Большой размер файла",
        max: "Можно прикрепить не более 5 файлов",
      },
    };
  },
  computed: {
    localAttachments: {
      get() {
        return this.attachments;
      },
      set(value) {
        this.$emit("onChangeAttachments", { value, fieldname: this.fieldname });
      },
    },
  },
  methods: {
    ...mapActions(["addAttachments"]),
    onAddFile(e) {
      this.currentErrorMessage = "";
      this.pending = true;
      const file = e.target.files[0];
      const formData = new FormData();
      const type = this.attachmentTypes[this.attachmentType];
      if (!file || !type) {
        return;
      }
      formData.append("file", file);
      formData.append("attachment_type", type);
      this.addAttachments(formData).then((response) => {
        if (this.localAttachments.length < 5) {
          this.pending = false;
          if (response.status === 201) {
            file.id = response.data.id;
            file.url = response.data.url;
            this.localAttachments.push(file);
            this.$emit("onChangeAttachments", this.fieldname);
          } else if (response.status === 413) {
            this.currentErrorMessage = this.errorMessage["file"];
          } else {
            alert(`Статус -> ${response.status}`);
          }
        } else {
          this.currentErrorMessage = this.errorMessage["max"];
          this.pending = false;
        }
      });
      e.target.value = "";
    },
    deleteFile(id) {
      this.localAttachments = this.localAttachments.filter(
        (el) => el.id !== id
      );

      // this.pending = false;
      // this.currentErrorMessage = "";
      //
      // if (this.localAttachments.length < 5) {
      //   this.pending = true;
      //   this.currentErrorMessage = "";
      // }
    },
  },
};
</script>
